import { MealCreditUpdatePayload } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { updateMealCreditApi } from 'src/components/oneCorp/features/MealCredit/components/Form/hooks/updateMealCreditApi';

import { SdkErrorResponse } from 'src/utilities/notifications';
import { IErrorResponse } from 'src/utilities/shared-types';

export interface UseUpdateMealCredit {
  updateMealCredit: (
    mealCreditPayload: MealCreditUpdatePayload
  ) => Promise<void>;
}

export interface UseUpdateMealCreditProps {
  corpId: string;
  onSuccess?: () => Promise<void>;
  onError?: (error: IErrorResponse | SdkErrorResponse) => Promise<void>;
}

export const useUpdateMealCredit = ({
  corpId,
  onSuccess,
  onError,
}: UseUpdateMealCreditProps): UseUpdateMealCredit => {
  async function updateMealCredit(
    mealCreditPayload: MealCreditUpdatePayload
  ): Promise<void> {
    try {
      await updateMealCreditApi({
        corpId,
        mealCreditPayload,
      });
      await onSuccess?.();
    } catch (error) {
      await onError?.(error);
    }
  }

  return { updateMealCredit };
};
